export default __webpack_public_path__ + "static/3drender_new-205d82346a377f3550a987478401dcec.png";